import { css } from '@emotion/react';

import { colors } from '../../../styles/colors';
import { ZeeFontBold } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';

export const contestAndWinnersTitleStyle = css`
  display: none;
  ${MQ.MediaMd} {
    display: block;
    color: ${colors.white};
    ${ZeeFontBold(18, 49)};
    text-align: center;
    leading-trim: both;
    text-edge: cap;
  }
`;

export const bannerBgImgStyle = css`
  height: auto;
  object-fit: fill;
  width: 100%;
`;

export const bannerWrapperStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const sponsorWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  margin-top: 24px;
`;

export const sponsorLogoWrapperStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  align-self: stretch;
`;

export const sponsorDescriptionStyle = css`
  margin-bottom: 36px;
  color: ${colors.white};
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  ${ZeeFontBold(40, 40)};
  font-style: italic;
  letter-spacing: -2px;
`;
